"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLinkNotarizationStatus = exports.SERVICE_LINK_SLOT_UNAVAILABLE = exports.ServiceLinkApproximateTime = void 0;
var ServiceLinkApproximateTime;
(function (ServiceLinkApproximateTime) {
    ServiceLinkApproximateTime["morning"] = "morning";
    ServiceLinkApproximateTime["afternoon"] = "afternoon";
    ServiceLinkApproximateTime["evening"] = "evening";
})(ServiceLinkApproximateTime || (exports.ServiceLinkApproximateTime = ServiceLinkApproximateTime = {}));
// The requested time is not in ServiceLink's current availability, so the borrower picks another
exports.SERVICE_LINK_SLOT_UNAVAILABLE = 'SERVICE_LINK_SLOT_UNAVAILABLE';
var ServiceLinkNotarizationStatus;
(function (ServiceLinkNotarizationStatus) {
    ServiceLinkNotarizationStatus["CREATED"] = "CREATED";
    ServiceLinkNotarizationStatus["SCHEDULE_REQUESTED"] = "SCHEDULE_REQUESTED";
    ServiceLinkNotarizationStatus["SCHEDULE_CONFIRMED"] = "SCHEDULE_CONFIRMED";
    ServiceLinkNotarizationStatus["CANCELLED"] = "CANCELLED";
    ServiceLinkNotarizationStatus["COMPLETED"] = "COMPLETED";
})(ServiceLinkNotarizationStatus || (exports.ServiceLinkNotarizationStatus = ServiceLinkNotarizationStatus = {}));
